import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Button, List } from "../../components";
import { AppContext, SET_IDCARD_STATE } from "../../components/AppProvider";
import AvatarUser from "../../components/UI/Avatar/AvatarUser";
import { CustomConfirmLayer } from "../../components/UI/Dialog";
import Labels from "../../components/UI/Label/Labels";
import DoctorInfoLayer from "../../components/UI/Layer/DoctorInfoLayer";
import ListCardInfo, { TextDiv } from "../../components/UI/List/ListCardInfo";
import { PostApi1972, PostApi275 } from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { checkNum10, stringToTelNo } from "../../modules/utils/CheckLogic";
import { getCookie, setCookie } from "../../modules/utils/cookie";
import { NativeAction } from "../../modules/utils/HandleWs";
import { IC, ListIcon } from "../../resources/Assets";
import { mapLayer, MapView, NaverMapAPI } from "../common/Modal/NaverMap";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { closeLayerFn, openLayerFn } from "../Layout";
import { getIdCard } from "../Nftf/Interface/NFTF/NativeApi";
import { BackgroundDiv, HeaderTitle } from "../Nftf/Receipt/ReceiptStyle";
import { VisitReceipt, pickerReStartFn } from "./Reservation.Layers";
import { getToday } from "./ResrvList";
import { request275 } from "./Surround";
import useTitle from "../../modules/hooks/useTitle";

const HospitalDetail = props => {
  const { userinfo, cfg, phonecfg, dispatch, idCardState } =
    useContext(AppContext);
  const [resrvType, setResrvType] = useState("0"); // 방문/전화 팝업 타입
  const [doctorList, setDoctorList] = useState(null);
  const [idCardRegist, setIdCardRegist] = useState(false);
  const [cardRegist, setCardRegist] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [tapTarget, setTapTarget] = useState("HSPT"); // HSPT || DR
  const [floatModalView, setFloatModalView] = useState(false);

  const [modalDoctorInfo, setModalDoctorInfo] = useState(null);
  const [mapView, setMapView] = useState(false);

  const [dialog, setDialog] = useState({
    type: "auth",
    title: "본인인증",
    msg: "해당 서비스를 정상적으로 이용하시려면 본인인증을 받으셔야합니다. 본인인증 화면으로 이동하겠습니까?",
    msg2: "",
    data: {},
  });

  useTitle("진료예약_병원상세");

  const handleCancelCB = () => {
    if (dialog.type === "check") {
      null;
    } else {
      closeLayerFn($(".confirm-layer"));
    }
  };

  const handleConfirmCB = () => {
    checkAction();
  };

  const checkAction = () => {
    sessionStorage.setItem("backUrl", "/surround");
    if (dialog.type === "check") {
      if (toggle) {
        setCookie("resrvCheckAlert", true, 365);
      }
      // _O.Open("/nftf/index/" + Base64.encode(JSON.stringify(dialog.data)));

      if (
        !localStorage.getItem("nftfNotice") ||
        JSON.parse(localStorage.getItem("nftfNotice")).check === false
      ) {
        _O.Open("/nftf/notice");
      } else {
        if (
          JSON.parse(localStorage.getItem("nftfNotice")).date ===
          new Date().getFullYear() +
            checkNum10(new Date().getMonth() + 1) +
            checkNum10(new Date().getDate())
        ) {
          _O.Open("/nftf/guide");
        } else {
          _O.Open("/nftf/notice");
        }
      }
    } else if (dialog.type === "auth") {
      _O.Open("/membership/certification");
    } else if (dialog.type === "dup") {
      _O.Open("/resrvList");
    }
  };

  const item = JSON.parse(Base64.decode(sessionStorage.getItem("hsptData")));

  const resrvLayer = (resrvType, hpNm, hpKey, setDoctorList, appDr) => {
    if (getCookie("isAuthOk") == 9) {
      openLayerFn($(".confirm-layer"));
      return;
    }

    let nDay = 0;
    let nHour = getToday("FULL").substring(8, 10);
    let nMin = getToday("FULL").substring(10, 12);

    if (nHour <= "12") {
      nDay = 0;
    } else {
      nDay = 1;
      nHour = parseInt(getToday("FULL").substring(8, 10)) - 12;
    }

    request275(userinfo, cfg, phonecfg, resrvType, hpKey, setDoctorList);

    openLayerFn($(".visit-receipt-layer"));
    pickerReStartFn(nDay, nHour, nMin);

    setResrvType(resrvType);

    if (item.hospital[0].appDr == "1") {
      $("#doctorList").show();
    } else {
      $("#doctorList").hide();
    }
    $("#hpNm").val(item.hospital[0].hpName);
  };

  const goReceipt = data => {
    goReceiptNotice();
  };

  const ReceiptNftf = () => {
    if (item.aplnBtnYn === "Y") {
      sessionStorage.setItem(
        "receiptData",
        Base64.encode(JSON.stringify(item.hospital[0]))
      );

      goReceipt(item.hospital[0]);
    } else {
      dupReceipt();
    }
  };

  const goReceiptNotice = () => {
    sessionStorage.setItem("backUrl", "/surround");
    if (
      !localStorage.getItem("nftfNotice") ||
      JSON.parse(localStorage.getItem("nftfNotice")).check === false
    ) {
      _O.Open("/nftf/notice");
    } else {
      if (
        JSON.parse(localStorage.getItem("nftfNotice")).date ===
        new Date().getFullYear() +
          checkNum10(new Date().getMonth() + 1) +
          checkNum10(new Date().getDate())
      ) {
        _O.Open("/nftf/guide");
      } else {
        _O.Open("/nftf/notice");
      }
    }
  };

  const dupReceipt = () => {
    setDialog(
      getCookie("isAuthOk") != 0
        ? {
            type: "auth",
            title: "본인인증",
            msg: "해당 서비스를 정상적으로 이용하시려면 본인인증을 받으셔야합니다. 본인인증 화면으로 이동하겠습니까?",
            data: {},
          }
        : {
            type: "dup",
            title: "진료예약안내",
            msg: "이미 신청한 진료가 있습니다 병원진료는 중복신청이 불가합니다. 예약현황을 확인 후 다시 이용하세요",
            data: {},
          }
    );
    openLayerFn($(".confirm-layer"));
  };

  useEffect(() => {
    if (idCardState.reload) {
      if (
        idCardState &&
        idCardState.data &&
        idCardState.data != null &&
        idCardState.data.value1 != "-1"
      ) {
        setIdCardRegist(true);
      } else {
        setIdCardRegist(false);
      }

      dispatch({
        type: SET_IDCARD_STATE,
        data: { type: "RELOAD" },
      });
    }
  }, [idCardState.reload]);

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          setCardRegist(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getMyCardList();
    getIdCard(userinfo.userName);
    getDoctorList();
  }, []);

  const nHour = getToday("FULL").substring(8, 10);
  const nMin = getToday("FULL").substring(10, 12);

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#ffffff");
  }, []);

  const getDoctorList = () => {
    PostApi275(userinfo, cfg, phonecfg, item.hospital[0].hpKey)
      .then(res => {
        setDoctorList(res.resultList);
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <Fragment>
      <ScrollToTop />
      <BackgroundDiv
        style={{ overflow: modalDoctorInfo != null ? "hidden" : "auto" }}>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() => {
              _O.Open(sessionStorage.getItem("backUrl"));
            }}>
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          <div>병원 상세 정보</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>

        <ListCardInfo
          status={"default"}
          borderColor={"#ffffff"}
          bodyInfoHeader={item.hospital[0].hpName}
          bodyInfoBody={[
            {
              left: (
                <TextDiv color="#333" fontWeight="600" style={{ flex: "none" }}>
                  {item.hospital[0].distance}
                </TextDiv>
              ),
              right: (
                <TextDiv color="#888" fontWeight="400">
                  {item.hospital[0].address3}
                </TextDiv>
              ),
            },
            {
              left: (
                <TextDiv color="#888" fontWeight="400" style={{ flex: "none" }}>
                  {stringToTelNo(item.hospital[0].phone)}
                </TextDiv>
              ),
              right: (
                <TextDiv
                  color="#6b65de"
                  fontWeight="600"
                  onClick={() => {
                    location.href = "tel:" + item.hospital[0].phone;
                  }}>
                  {"전화문의 >"}
                </TextDiv>
              ),
            },
          ]}
          bodyInfoBodyAction={() => console.log("상세페이지 이동")}
          bodyInfoBottom={
            <Labels
              labels={[
                (item.hospital[0].receiptUseType.toString() === "2" ||
                  item.hospital[0].receiptUseType.toString() === "9") && {
                  status: "active_green",
                  leftIcon: IC.camera.ICON_CAMERA_GREEN,
                  text: "비대면진료",
                },
                // {
                //   status: "active",
                //   text: "label_active",
                // },
                item.hospital[0].hpTypeNm &&
                  item.hospital[0].hpTypeNm != undefined &&
                  item.hospital[0].hpTypeNm != null &&
                  item.hospital[0].hpTypeNm != "" && {
                    status: "default",
                    text: item.hospital[0].hpTypeNm,
                  },
              ]}
            />
          }
          bodyIcon={[
            {
              icon: IC.etc.ICON_HSPT_DEFAULT,
              action: false,
              thumnail: true,
            },
          ]}
        />

        <div style={{ display: "flex", flexFlow: "nowrap", width: "100%" }}>
          <TapDiv
            active={tapTarget === "HSPT" ? true : false}
            onClick={() => setTapTarget("HSPT")}>
            병원소개
          </TapDiv>
          <TapDiv
            active={tapTarget === "DR" ? true : false}
            onClick={() => setTapTarget("DR")}>
            의료진
          </TapDiv>
        </div>

        <ScrollContent>
          {tapTarget === "HSPT" ? (
            <Fragment>
              <Section>
                <TextTitle>진료시간</TextTitle>

                <TextBoxGray>
                  <div
                    style={{
                      display: "flex",
                      flexFlow: "nowrap",
                      width: "100%",
                      gap: "20px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        flexFlow: "column",
                        gap: "8px",
                      }}>
                      {/* <TextTitle>진료가능 요일</TextTitle> */}
                      <TextTitle>병원 진료시간</TextTitle>
                      <TextTitle>비대면 진료시간</TextTitle>
                      {/* <TextTitle>병원 점심시간</TextTitle> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexFlow: "column",
                        gap: "8px",
                      }}>
                      {/* <SubTextTitle>월, 화, 수, 목, 금</SubTextTitle> */}
                      <SubTextTitle>
                        {item.hospital[0].openTime
                          ? item.hospital[0].openTime.substring(0, 2) +
                            ":" +
                            item.hospital[0].openTime.substring(2, 4) +
                            " ~ " +
                            item.hospital[0].closeTime.substring(0, 2) +
                            ":" +
                            item.hospital[0].closeTime.substring(2, 4)
                          : "미등록"}
                      </SubTextTitle>
                      <SubTextTitle>
                        {item.hospital[0].callSTime
                          ? item.hospital[0].callSTime.substring(0, 2) +
                            ":" +
                            item.hospital[0].callSTime.substring(2, 4) +
                            " ~ " +
                            item.hospital[0].callETime.substring(0, 2) +
                            ":" +
                            item.hospital[0].callETime.substring(2, 4)
                          : "미등록"}
                      </SubTextTitle>
                      {/* <SubTextTitle>08:30 ~ 18~30</SubTextTitle> */}
                    </div>
                  </div>
                </TextBoxGray>
              </Section>

              <Section>
                <TextTitle>
                  <span>병원위치</span>
                  <SubTextTitle>{item.hospital[0].address3}</SubTextTitle>
                </TextTitle>

                <div
                  // style={{ opacity: 1, zIndex: 99999 }}
                  style={{ opacity: 1, zIndex: 200 }}
                  onClick={() =>
                    mapLayer(phonecfg, console.log, item.hospital[0])
                  }>
                  <div
                    style={{
                      display: "flex",
                      flexFlow: "nowrap",
                      width: "100%",
                      height: "160px",
                      gap: "20px",
                    }}>
                    <NaverMapAPI
                      locationInfo={{
                        latitude: item.hospital[0].latitude,
                        longitude: item.hospital[0].longitude,
                      }}
                      popupType="HSPT"
                      zoomControl={false}
                      customControl={false}
                      mapId="map2"
                      size={{
                        width: window.innerWidth - 40,
                        height: "160px",
                      }}
                      draggable={false}
                    />
                  </div>
                </div>
              </Section>

              <Section>
                <TextTitle>
                  <span>진료 과목</span>
                </TextTitle>

                <Labels
                  labels={[
                    item.hospital[0].hpTypeNm &&
                      item.hospital[0].hpTypeNm != undefined &&
                      item.hospital[0].hpTypeNm != null &&
                      item.hospital[0].hpTypeNm != "" && {
                        status: "default",
                        text: item.hospital[0].hpTypeNm,
                      },
                  ]}
                />
              </Section>
            </Fragment>
          ) : (
            <Fragment>
              <Section>
                <TextTitleArea>
                  <TextTitle>전체 의료진</TextTitle>
                  <TextTitleGray>
                    {doctorList != null && doctorList.length > 0
                      ? doctorList.length
                      : "0"}
                    명
                  </TextTitleGray>
                </TextTitleArea>

                {doctorList != null && doctorList.length > 0 && (
                  <Fragment>
                    {doctorList.map((doctor, drIdx) => (
                      <List
                        key={"drList" + drIdx}
                        data={{
                          STATUS: "default",
                          ACTION_ALL: () => {
                            setFloatModalView(true);
                            setModalDoctorInfo(doctor);
                          },
                          L_ICON: (
                            <AvatarUser
                              active={
                                doctor.doctor[0].DrName.split(" ").length == 1
                                  ? true
                                  : false
                              }
                            />
                          ),
                          TITLE: [
                            <div style={{ display: "flex", gap: "4px" }}>
                              {doctor.doctor[0].doctorName}
                              {doctor.doctor[0].DrName.split(" ").length ==
                                1 && <img src={IC.camera.ICON_CAMERA_GREEN} />}
                            </div>,
                          ],
                          SUB_TEXT: {
                            status: "default",
                            text: (
                              <Labels
                                labels={[
                                  {
                                    status: "default",
                                    text: doctor.doctor[0].mdclSubNm,
                                  },
                                ]}
                              />
                            ),
                          },
                          R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                          ACTION: () => {
                            setFloatModalView(true);
                            setModalDoctorInfo(doctor);
                          },
                        }}
                      />
                    ))}
                  </Fragment>
                )}
              </Section>
            </Fragment>
          )}
        </ScrollContent>

        <div style={{ height: "102px" }}></div>
        {/* bottom */}
        <div
          style={{
            position: "fixed",
            zIndex: "99999",
            width: "calc(100% - 40px)",
            padding: "24px 20px",
            bottom: "0px",
            display: "flex",
            gap: "8px",
            backgroundColor: "#FFF",
            background:
              "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.7) 16%, #fff 40%)",
          }}>
          {item.hospital[0].myhp != "0"
            ? [
                (item.hospital[0].receiptUseType.toString() === "1" ||
                  item.hospital[0].receiptUseType.toString() === "9") &&
                  item.hospital[0].appSTime <= nHour + nMin &&
                  item.hospital[0].appETime >= nHour + nMin && (
                    <Button
                      severity="primary_light"
                      disable="off"
                      clickEvent={() => {
                        if (item.aplnBtnYn === "Y") {
                          resrvLayer(
                            "0",
                            item.hospital[0].hpName,
                            item.hospital[0].hpKey,
                            setDoctorList,
                            item.hospital[0].appDr
                          );
                          dispatch({ type: "SET_NFTF_DOCTOR", data: null });
                        } else {
                          dupReceipt();
                        }
                      }}>
                      방문진료 접수신청
                    </Button>
                  ),
                (item.hospital[0].receiptUseType.toString() === "2" ||
                  item.hospital[0].receiptUseType.toString() === "9") &&
                  item.hospital[0].callETime >= nHour + nMin && (
                    <Button
                      severity="primary"
                      disable="off"
                      clickEvent={() => {
                        ReceiptNftf();
                        dispatch({ type: "SET_NFTF_DOCTOR", data: null });
                      }}>
                      비대면진료 접수신청
                    </Button>
                  ),
              ]
            : [
                <Button
                  severity="light"
                  disable="on"
                  clickEvent={e => e.preventDefault()}>
                  접수가능 시간이 아닙니다
                </Button>,
              ]}
        </div>
      </BackgroundDiv>

      <VisitReceipt
        doctorList={doctorList}
        hpKey={item.hospital[0].hpKey}
        resrvType={resrvType}
        callSTime={item.hospital[0].callSTime}
        callETime={item.hospital[0].callETime}
      />

      <CustomConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={handleConfirmCB}
        handleCancelCBText={
          getCookie("isAuthOk") != 0
            ? "닫기"
            : dialog.type === "check"
            ? "취소"
            : "닫기"
        }
        handleCancelCB={handleCancelCB}
        // handleConfirmCBText={getCookie("isAuthOk") != 0 ? "확인" : "예약현황 확인"}
        handleConfirmCBText={
          dialog.type === "auth"
            ? "확인"
            : dialog.type === "dup"
            ? "예약현황 확인"
            : "확인"
        }
        // setCookieBtn={dialog.type === "check" ? true : false}
        toggle={toggle}
        setToggle={setToggle}
      />

      {floatModalView && (
        <DoctorInfoLayer
          fn_close={() => {
            setFloatModalView(false);
            setModalDoctorInfo(null);
          }}
          doctor={modalDoctorInfo}
          item={item}
          resrvLayer={resrvLayer}
          dupReceipt={dupReceipt}
          ReceiptNftf={ReceiptNftf}
          setDoctorList={setDoctorList}
        />
      )}

      <MapView locationInfo={item.hospital[0]} popupType="HP" />
    </Fragment>
  );
};

const Section = styled.div`
  /* width: 100%; */
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 16px;
  padding: 20px;
`;

const SplitLine = styled.div`
  height: 8px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  gap: 4px;
  padding: 16px 20px;
  background-color: #fafafa;
`;

const TextBoxGray = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 8px;
  padding: 16px;
  background-color: #f7f7fa;
  border-radius: 4px;
`;

const TextTitle = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

const TextTitleGray = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #888;
`;

const SubTextTitle = styled.div`
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #666;
`;

const TapDiv = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 16px 10px;
  text-align: left;
  /* color: #aaa; */
  ${props =>
    props.active === true
      ? css`
          color: #6b65de;
          border-bottom: solid 1px #6b65de;
        `
      : css`
          color: #aaaaaa;
          border-bottom: solid 1px #eeeeee;
        `}

  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
`;

const TextTitleArea = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const ScrollContent = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  padding-bottom: 102px;
`;
export default HospitalDetail;
